import { WishlistItemsMgr } from '../toolbox/wishlistItemsMgr';

type confirmDialog = InstanceType<ReturnType<typeof import('widgets/global/ConfirmDialog').default>>;
type CartMgrInstance = ReturnType<typeof import('widgets/cart/CartMgr').default>;

type TMoveToWishlistResponse = { error: boolean; itemAlreadyExists: boolean; wishlistItems: unknown[]; };

/**
 * @param CartMgr Base widget for extending
 * @returns Add to Wishlist Mixin class
 */
export default function (CartMgr: CartMgrInstance) {
    /**
     * @category widgets
     * @subcategory cart
     * @class WishlistCartMixin
     * @augments CartMgr
     * @classdesc wish list cart mixin with next features:
     * 1. Update Wish List state while the product was added to the Wish List from the Cart/Mini Cart
     * This class is not intended to have a separate DOM representation.
     */
    class WishlistCartMixin extends CartMgr {
        /**
         * @description Update Wish List state when product was added to the WLS from the Cart/Mini Cart
         * @param confirmationDialog Target popup
         */
        moveProductToWishlist(confirmationDialog: confirmDialog) {
            return super.moveProductToWishlist(confirmationDialog)
                .then((responses) => {
                    const response = <TMoveToWishlistResponse>responses[0];

                    if (response.error && !response.itemAlreadyExists) {
                        return responses;
                    }

                    const wishlistItemsMgr = WishlistItemsMgr.getInstance();

                    wishlistItemsMgr.updateWishlistItems(response.wishlistItems);
                    this.eventBus().emit('product.addedToWishlist', response.wishlistItems.length > 0, true);

                    return responses;
                });
        }
    }

    return WishlistCartMixin;
}
